import {FC} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputText, InputNumber, InputDate} from '../../Input'
interface Props {
  isDisabled?: boolean
}
const AditionalFormHoteleria: FC<Props> = ({isDisabled = false}) => {
  const {
    register,
    formState: {errors},
  } = useFormContext()

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Texto adicional 1:</label>
        <InputText
          name='Campoadicionaltxt1'
          textPlaceholder='Escribe el texto adicional'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Texto adicional 2:</label>
        <InputText
          name='Campoadicionaltxt2'
          textPlaceholder='Escribe el texto adicional'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Texto adicional 3:</label>
        <InputText
          name='Campoadicionaltxt3'
          textPlaceholder='Escribe el texto adicional'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Texto adicional 4:</label>
        <InputText
          name='Campoadicionaltxt4'
          textPlaceholder='Escribe el texto adicional'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Texto adicional 5:</label>
        <InputText
          name='Campoadicionaltxt5'
          textPlaceholder='Escribe el texto adicional'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Número adicional 1:</label>
        <InputNumber
          name='Campoadicionalnum1'
          textPlaceholder='Escribe el número'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Número adicional 2:</label>
        <InputNumber
          name='Campoadicionalnum2'
          textPlaceholder='Escribe el número'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Número adicional 3:</label>
        <InputNumber
          name='Campoadicionalnum3'
          textPlaceholder='Escribe el número'
          register={register}
          errors={errors}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Fecha adicional 1:</label>
        <InputDate name='CampoadicionalFec1' register={register} errors={errors} />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Fecha adicional 2:</label>
        <InputDate name='CampoadicionalFec2' register={register} errors={errors} />
      </div>
    </div>
  )
}

export default AditionalFormHoteleria
